import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-color-picker',
  templateUrl: './color-picker.component.html',
  styleUrl: './color-picker.component.scss',
  standalone: false,
})
export class ColorPickerComponent {
  @Input() title: string;
  @Input() color: string;

  @Output() public colorSelected = new EventEmitter<string>();

  onColorChange() {
    this.colorSelected.emit(this.color);
  }
}
